import { createReducer, INITIAL_STATE } from '../../../shared/redux';

export const CHALLENGE_NEW_PASSWORD_REQUIRED_ISSUED = '@auth/CHALLENGE_NEW_PASSWORD_REQUIRED_ISSUED';
export const CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED = '@auth/CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED';
export const CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED = '@auth/CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED';
export const CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED = '@auth/CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED';

export const isChallengeNewPasswordLoading = state => state.auth.challengeNewPasswordRequired.loading;

export const issueChallengeNewPasswordRequired = () => ({
    type: CHALLENGE_NEW_PASSWORD_REQUIRED_ISSUED,
    payload: {},
});

export const submitChallengeNewPasswordRequired = ({ password, confirmPassword, attributes }) => ({
    type: CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED,
    payload: { password, confirmPassword, attributes },
});

export const acceptChallengeNewPasswordRequired = ({ user }) => ({
    type: CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED,
    payload: { user },
});

export const rejectChallengeNewPasswordRequired = ({ code, error }) => ({
    type: CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED,
    payload: { code, error },
});

export const challengeNewPasswordRequiredReducer = createReducer({
    [INITIAL_STATE]: {
        loading: false,
    },

    [CHALLENGE_NEW_PASSWORD_REQUIRED_SUBMITTED]: state => ({ ...state, loading: true }),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_ACCEPTED]: state => ({ ...state, loading: false }),
    [CHALLENGE_NEW_PASSWORD_REQUIRED_REJECTED]: state => ({ ...state, loading: false }),
});
